"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legend = exports.ChildrenCheckboxes = exports.ChildCheckboxWrapper = exports.CheckboxList = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreListGroup = _interopRequireDefault(require("@vfuk/core-list-group"));

var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CheckboxList = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "CheckboxFieldSetstyle__CheckboxList",
  componentId: "sc-1g03o3x-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;align-items:flex-start;", ";", " ", ""], props.theme.mixins.spacing('gap', 3), props.hasLabel !== false && (0, _styledComponents.css)(["", ";"], props.theme.mixins.spacing('margin-top', 2)), props.orientation === 'horizontal' && (0, _styledComponents.css)(["", ""], props.theme.mixins.respondTo.md((0, _styledComponents.css)(["flex-direction:row;"]))));
});
exports.CheckboxList = CheckboxList;

var Legend = _styledComponents["default"].legend.withConfig({
  displayName: "CheckboxFieldSetstyle__Legend",
  componentId: "sc-1g03o3x-1"
})(function (props) {
  return (0, _styledComponents.css)(["", ""], props.theme.mixins.srOnly());
});

exports.Legend = Legend;
var ChildrenCheckboxes = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "CheckboxFieldSetstyle__ChildrenCheckboxes",
  componentId: "sc-1g03o3x-2"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;align-items:flex-start;", ";", ";", " ", ""], props.theme.mixins.spacing('gap', 3), props.theme.mixins.spacing('margin-top', 3), props.orientation === 'vertical' && (0, _styledComponents.css)(["", ";"], props.theme.mixins.spacing('padding-left', 6)), props.orientation === 'horizontal' && (0, _styledComponents.css)(["", ""], props.theme.mixins.respondTo.md((0, _styledComponents.css)(["flex-direction:row;"]))));
});
exports.ChildrenCheckboxes = ChildrenCheckboxes;
var ChildCheckboxWrapper = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "CheckboxFieldSetstyle__ChildCheckboxWrapper",
  componentId: "sc-1g03o3x-3"
})(function () {
  return (0, _styledComponents.css)([""]);
});
exports.ChildCheckboxWrapper = ChildCheckboxWrapper;
//# sourceMappingURL=CheckboxFieldSet.style.js.map